function cartItems() {
  let clearChecks = $('.cart__clear');
  let inputs = $('.cart__label input');
  clearChecks.on('click', function() {
    Array.from(inputs).forEach(input => {
      if ($(input).prop('checked')  == true) {
        $(input).closest('.cart__block').remove();
      }
    });
  });

  $('.cart__block__remove').on('click', function() {
    $(this).closest('.cart__block').remove();
  });

  $('.cart__block__minus').click(function() {
    let $block = $(this).closest('.cart__block');
    let $total = $block.find('.cart__block__total input');
    let count = parseInt($total.val());

    if (count > 1) {
      count--;
      $total.val(count);
    }
  });


  $('.cart__block__plus').click(function() {
    let $block = $(this).closest('.cart__block');
    let $total = $block.find('.cart__block__total input');
    let count = parseInt($total.val());

    if (count < 99) {
      count++;
      $total.val(count);
    }
  });
  
  
}
cartItems();